import {CreateAccessor} from "mobx-graphlink";
import {GetMapObjects} from "../../../Server/DB/mapObjects.js";
import {MapObject} from "../../../Server/DB/mapObjects/@MapObject.js";

export const GetMapState = CreateAccessor({ctx: 1}, function(mapID: string|n) {
	return this.store.main.maps.mapStates.get(mapID!); // nn: get() actually accepts undefined
});

export const GetActiveObjectID = CreateAccessor({}, (mapID: string)=>{
	return GetMapState(mapID)?.activeObject;
});
export const GetActiveObject = CreateAccessor({}, (mapID: string)=>{
	const mapState = GetMapState(mapID);
	if (mapState == null) return null;
	const mapObjects = GetMapObjects(mapID);
	const activeObjectID = mapState.activeObject;
	return mapObjects.find(a=>a.id == activeObjectID) || null;
});

export const GetSelectedObjectIDs = CreateAccessor({}, (mapID: string)=>{
	return GetMapState(mapID)?.selectedObjects ?? [];
});
// temporary solution to this (for now it's more efficient to get all objects, and match ids; later, will probably not be)
export const GetSelectedObjects = CreateAccessor({}, (mapID: string)=>{
	const mapState = GetMapState(mapID);
	if (mapState == null) return [];
	const mapObjects = GetMapObjects(mapID);
	return mapState.selectedObjects.map(id=>mapObjects.find(a=>a.id == id)).filter(a=>a != null) as MapObject[];
});